import type { UseMutationOptions } from "react-query";
import { useMutation } from "react-query";

import { connectionsApi } from "@/react/api/connectionsApi";

export const useWithdrawConnection = (
  options?: UseMutationOptions<any, Error, string>,
) =>
  useMutation({
    mutationFn: (connectionId: string) =>
      connectionsApi.withdrawConnection(connectionId),
    ...options,
  });
